export default "__VITE_ASSET__f486deec__"